/**
 * ACQ Anchor Links - Smooth scroll handling for acquisition pages
 * Handles both ID-based (#product-offer) and class-based (.acq-product-offer) anchors
 */
(function() {
  'use strict';

  var HEADER_SELECTORS = [
    '.shopify-section-header',
    '.header-wrapper',
    'header',
    '#shopify-section-header'
  ];

  var STICKY_SELECTORS = [
    '.acq-sticky-atc',
    '[data-sticky-atc]'
  ];

  function getHeaderOffset() {
    var offset = 20; // Base padding

    // Account for sticky header
    HEADER_SELECTORS.forEach(function(sel) {
      var header = document.querySelector(sel);
      if (header) {
        var styles = window.getComputedStyle(header);
        if (styles.position === 'fixed' || styles.position === 'sticky') {
          offset += header.offsetHeight;
        }
      }
    });

    return offset;
  }

  function scrollToTarget(target) {
    if (!target) return false;

    var offset = getHeaderOffset();
    var targetTop = target.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({
      top: targetTop,
      behavior: 'smooth'
    });

    // Update URL hash without jumping
    if (target.id) {
      history.pushState(null, null, '#' + target.id);
    }

    return true;
  }

  function findTarget(selector) {
    if (!selector) return null;

    // Clean the selector
    selector = selector.trim();

    // Try as-is first (for #id or .class)
    try {
      var target = document.querySelector(selector);
      if (target) return target;
    } catch (e) {
      // Invalid selector, continue to fallbacks
    }

    // If it starts with #, try without (in case it's a plain ID)
    if (selector.startsWith('#')) {
      var id = selector.slice(1);
      var target = document.getElementById(id);
      if (target) return target;

      // Also try finding an element with data-anchor-id matching
      target = document.querySelector('[data-anchor-id="' + id + '"]');
      if (target) return target;
    }

    // If it starts with ., try finding by class
    if (selector.startsWith('.')) {
      var className = selector.slice(1);
      var target = document.querySelector('.' + className);
      if (target) return target;

      // Try data-anchor-id as fallback
      target = document.querySelector('[data-anchor-id="' + className + '"]');
      if (target) return target;
    }

    // Try as plain text (could be an ID without #)
    var target = document.getElementById(selector);
    if (target) return target;

    // Try data-anchor-id
    target = document.querySelector('[data-anchor-id="' + selector + '"]');
    if (target) return target;

    return null;
  }

  function handleClick(e) {
    var link = e.target.closest('a[href*="#"], button[data-scroll-to]');
    if (!link) return;

    var href = link.getAttribute('href') || link.getAttribute('data-scroll-to');
    if (!href) return;

    // Extract the hash/anchor portion
    var hashIndex = href.indexOf('#');
    if (hashIndex === -1) return;

    var anchor = href.slice(hashIndex);
    if (anchor.length <= 1) return; // Just "#"

    // Check if this is a same-page link
    var url = new URL(href, window.location.href);
    if (url.pathname !== window.location.pathname && url.origin === window.location.origin) {
      // Different page, let the browser handle it
      return;
    }

    var target = findTarget(anchor);
    if (target) {
      e.preventDefault();
      scrollToTarget(target);
    }
  }

  function handleHashOnLoad() {
    var hash = window.location.hash;
    if (hash && hash.length > 1) {
      // Small delay to ensure page is rendered
      setTimeout(function() {
        var target = findTarget(hash);
        if (target) {
          scrollToTarget(target);
        }
      }, 100);
    }
  }

  // Initialize
  document.addEventListener('click', handleClick);

  // Handle initial hash
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleHashOnLoad);
  } else {
    handleHashOnLoad();
  }

  // Expose globally for manual triggering
  window.acqScrollTo = function(selector) {
    var target = findTarget(selector);
    return scrollToTarget(target);
  };
})();
